import React from 'react';
import PropTypes from 'prop-types';
// import GdsEvent from '~/glm/models/gds/gds-event-model';
// import EventCollection from '../../models/gds/event-collection';
import { Body1 } from '@xo-union/tk-ui-typography';
import { compose } from '@xo-union/react-css-modules';
import { MultiSelectGroup, Checkbox } from '@xo-union/tk-component-switches';
import { Button } from '@xo-union/tk-component-buttons';
import GuestCandidateCollection from '~/glm/models/shared/guest-import/guest-candidate-collection';
import ImportSpreadsheetError from '~/glm/components/import-spreadsheet/import-spreadsheet-error';
import styles from './import-spreadsheet-footer.scss';

export const isDisabled = guestCandidates =>
  guestCandidates.count === 0 || guestCandidates.count !== guestCandidates.validCount;

const ImportSpreadsheetFooter = ({
  events,
  isProcessing,
  guestCandidates,
  handleImportClick,
  errors,
  selectedEvents,
  handleChange,
}) => (
  <div className={styles.footer}>
    <div className={styles.eventList}>
      <Body1>Invite all new guests to:</Body1>
      <MultiSelectGroup values={selectedEvents} onChange={handleChange}>
        {events.map(e => (
          <Checkbox key={e.id} value={e.id} classes={compose({ container: styles.container })}>
            {e.name}
          </Checkbox>
        ))}
      </MultiSelectGroup>
    </div>
    <div className={styles.buttonContainer}>
      <ImportSpreadsheetError isProcessing={isProcessing} errors={errors} />
      <Button size="lg" disabled={isProcessing || isDisabled(guestCandidates)} onClick={handleImportClick}>
        Add Guests
      </Button>
    </div>
  </div>
);

ImportSpreadsheetFooter.propTypes = {
  events: PropTypes.array,
  handleImportClick: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool,
  guestCandidates: PropTypes.instanceOf(GuestCandidateCollection).isRequired,
  errors: PropTypes.shape({
    names: PropTypes.bool,
    email: PropTypes.bool,
    phone: PropTypes.bool,
  }),
  selectedEvents: PropTypes.array,
  handleChange: PropTypes.func,
};

export default ImportSpreadsheetFooter;
